// QUIEN LE PONE ENTRENADOR A UN CLIENTE, EN PANTALLA (12-10, decision de Francisco).
//
// "Que los entrenadores vean todos los clientes no importa si son suyos o no, y puedan hacer
// modificaciones o asignarselos a ellos mismos aunque ya tengan entrenador asignado."
//
// La regla la guarda el servidor (`backend/core/security.py`, `por_que_no_asigna_entrenador`):
// el administrador asigna a quien sea y quita; el entrenador solo se lo asigna A SI MISMO,
// tenga o no el cliente otro entrenador. Aqui esta lo que ensenan la ficha del cliente y la
// lista de Clientes con esa regla, para que las dos digan lo mismo.

/** Que se le ofrece a quien mira: 'elegir' (el desplegable del administrador), 'asignarmelo'
 *  (el entrenador, sobre un cliente que no lleva el) o 'mio' (el entrenador, sobre uno suyo:
 *  no hay nada que hacer). Otro rol, nada. */
export function accionDeEntrenador({ rol, miId, entrenadorId } = {}) {
    if (rol === 'admin') return 'elegir';
    if (rol !== 'trainer') return null;
    return entrenadorId && entrenadorId === miId ? 'mio' : 'asignarmelo';
}

/** Lo que se pregunta antes de quedarse un cliente que ya lleva OTRO entrenador, o null si
 *  no lleva a nadie (entonces no se pregunta nada). */
export function avisoAlAsignarmelo({ cliente, entrenadorId, entrenadorNombre, miId } = {}) {
    if (!entrenadorId || entrenadorId === miId) return null;
    const quien = cliente || 'Este cliente';
    const lleva = entrenadorNombre || 'otro entrenador';
    return {
        title: `¿Asignarte a ${quien}?`,
        description: `${quien === 'Este cliente' ? 'A este cliente' : `A ${quien}`} lo lleva ahora ${lleva}; pasará a ti.`,
        confirmLabel: 'Asignármelo',
    };
}
